// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Calendar_Types_RestaurantLocalDay from "../Restaumatic.Calendar.Types.RestaurantLocalDay/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.eqRestaurantLocalDay));
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var compare1 = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ Data_Maybe.ordMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.ordRestaurantLocalDay));
var codeIsSymbol = {
    reflectSymbol: function () {
        return "code";
    }
};
var expiresOnIsSymbol = {
    reflectSymbol: function () {
        return "expiresOn";
    }
};
var promotionNameIsSymbol = {
    reflectSymbol: function () {
        return "promotionName";
    }
};
var CouponDataIsSymbol = {
    reflectSymbol: function () {
        return "CouponData";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var CouponData = function (x) {
    return x;
};
var toFillFormTypeCouponData = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeCouponData_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCouponData = function (dictHasField) {
    return dictHasField;
};
var eqCouponData = {
    eq: function (x) {
        return function (y) {
            return x.code === y.code && eq1(x.expiresOn)(y.expiresOn) && x.promotionName === y.promotionName;
        };
    }
};
var ordCouponData = {
    compare: function (x) {
        return function (y) {
            var v = compare(x.code)(y.code);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = compare1(x.expiresOn)(y.expiresOn);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare(x.promotionName)(y.promotionName);
        };
    },
    Eq0: function () {
        return eqCouponData;
    }
};
var genericCouponData = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCouponData = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCouponData)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(codeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(expiresOnIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(promotionNameIsSymbol)(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.showRestaurantLocalDay)))(Data_Show.showString))))(CouponDataIsSymbol))
};
var unscrambleDecodeCouponData = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCouponData)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(codeIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(expiresOnIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.unscrambleDecodeRestaurantLocalDay))(/* #__PURE__ */ Unscramble.decodeRecordCons(promotionNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodeCouponData = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCouponData)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CouponDataIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(promotionNameIsSymbol)(encodeWithOptionsOther))(expiresOnIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Calendar_Types_RestaurantLocalDay.encodeRestaurantLocalDay))))(codeIsSymbol)(encodeWithOptionsOther)))))
};
var decodeCouponData = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCouponData)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CouponDataIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(promotionNameIsSymbol)(decodeWithOptionsOther)())(expiresOnIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Calendar_Types_RestaurantLocalDay.decodeRestaurantLocalDay)))())(codeIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    CouponData,
    genericCouponData,
    eqCouponData,
    showCouponData,
    ordCouponData,
    encodeCouponData,
    decodeCouponData,
    unscrambleDecodeCouponData,
    toFillFormTypeCouponData,
    hasFieldCouponData,
    newtypeCouponData_
};
